module.exports = __webpack_public_path__ + "static/media/gb_flag.aae31d4f.jpg";